import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Understand Business",
    desc: "Deep discovery sessions. We learn your model, teams, bottlenecks, and ambitions before drawing a single line.",
  },
  {
    n: "02",
    title: "Analyze Workflow",
    desc: "We map every process — what runs well, what breaks, what should be automated. Nothing is assumed.",
  },
  {
    n: "03",
    title: "Build Custom System",
    desc: "Tailored modules, dashboards, automations. Integrated AI where it adds compounding value.",
  },
  {
    n: "04",
    title: "Deploy & Train",
    desc: "Production-grade rollout, real-time onboarding, role-based training. Your team is operational from day one.",
  },
  {
    n: "05",
    title: "Scale With Growth",
    desc: "As your business evolves, so does NOEX. New modules, new integrations, new dashboards — on demand.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white text-neutral-950 py-24 md:py-36 border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-neutral-500">
              03 — Process
            </span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter mt-6 leading-[1.05]">
              From conversation
              <br />
              <span className="text-neutral-400">to operating system.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-neutral-600 font-light leading-relaxed">
              A disciplined five-step engagement. No bloated rollouts, no template
              traps. Just systems that actually fit.
            </p>
          </div>
        </div>

        <div className="space-y-0">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: 0.05 * i }}
              className="grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 border-t border-neutral-200 group hover:bg-neutral-50 transition-colors duration-500 px-2 md:px-4 -mx-2 md:-mx-4 rounded-xl"
              data-testid={`process-step-${i + 1}`}
            >
              <div className="col-span-2 md:col-span-1">
                <span className="text-sm md:text-base font-mono text-neutral-400">{s.n}</span>
              </div>
              <div className="col-span-10 md:col-span-5">
                <h3 className="font-display text-2xl md:text-4xl font-light tracking-tight leading-tight">
                  {s.title}
                </h3>
              </div>
              <div className="col-start-3 col-span-10 md:col-start-7 md:col-span-6">
                <p className="text-base md:text-lg text-neutral-600 font-light leading-relaxed max-w-xl">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
